module.exports = __webpack_public_path__ + "a5b6bc54c22578f33f59929472bb6ab0.png";